import { useEffect, useState } from 'react';

import { XIcon } from 'lucide-react';

import Button from '@/components/ui/button';

const LOCAL_STORAGE_KEY = 'typeformClosed';

export default function Survey() {
  const [isVisible, setIsVisible] = useState(false);

  const handleCloseBanner = () => {
    localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
    setIsVisible(false);
  };

  useEffect(() => {
    const typeformClosed = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!typeformClosed) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 600000); // 10 minutes in milliseconds

      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (isVisible) {
      const script = document.createElement('script');
      script.src = '//embed.typeform.com/next/embed.js';
      script.async = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <section className="fixed top-0 left-0 bottom-0 w-full z-50 flex justify-center items-center bg-black/80 backdrop-blur-sm">
      <div className="bg-[#15161F] p-8 rounded-lg text-center relative w-full lg:max-w-[calc(50vw+64px)] h-[564px]">
        <Button
          variant="icon"
          size="icon"
          className="absolute -top-4 -right-4 hover:bg-transparent hover:text-green-400"
          onClick={handleCloseBanner}
        >
          <XIcon className="size-6" />
        </Button>
        <div
          data-tf-live="01J5DJ7MSPAE0ZVQ6V0M4G2P81"
          className="survey-wrapper"
        ></div>
      </div>
    </section>
  );
}
